import template from './template.html.twig';

const FALLBACK_LANGUAGE   = 'de';
const SUPPORTED_LANGUAGES = ['de', 'en'];

const { Component, Store } = Shopware;

const LINKS = {
    de: {
        documentation(pluginName) {
            return 'https://redirect.netinventors.de/de/' + pluginName + '/anleitung';
        },

        support() {
            return 'https://redirect.netinventors.de/de/support';
        },

        description(pluginName) {
            return 'https://redirect.netinventors.de/de/' + pluginName + '/kaufen';
        }
    },
    en: {
        documentation(pluginName) {
            return 'https://redirect.netinventors.de/en/' + pluginName + '/manual';
        },

        support() {
            return 'https://redirect.netinventors.de/en/support';
        },

        description(pluginName) {
            return 'https://redirect.netinventors.de/en/' + pluginName + '/buy';
        }
    }
};

export { LINKS, FALLBACK_LANGUAGE, SUPPORTED_LANGUAGES };

Component.register('neti-next-order-amount-handler-config-links', {
    template,

    props: {
        name: String,
        required: true,
    },

    computed: {
        pluginName() {
            return this.name.substring(0, this.name.indexOf('.'));
        },

        currentLanguage() {
            const language = Store.get('session').adminLocaleLanguage;

            if (SUPPORTED_LANGUAGES.includes(language)) {
                return language;
            }

            return FALLBACK_LANGUAGE;
        },

        documentationLink() {
            return LINKS[this.currentLanguage].documentation(this.pluginName);
        },

        supportLink() {
            return LINKS[this.currentLanguage].support();
        },

        descriptionLink() {
            return LINKS[this.currentLanguage].description(this.pluginName);
        }
    }
});